import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import {
  Alert,
  Avatar,
  CardMedia,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Divider,
  Grid,
  Chip,
} from '@mui/material';
import EvStationIcon from '@mui/icons-material/EvStation';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import BookIcon from '@mui/icons-material/Book';
import { keyframes } from '@mui/system';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { useFetch } from '../../hook/useFetch';
import { rutas } from '../../rutas/rutas';
import { exit, setInformacion } from '../../storage/slices/usuarios';

import { getCookie } from '../../utils/getCookie';
import axios from 'axios';

import logo from '../../Web Mundo/logo.png';
import hueso from '../../Web Mundo/hueso.png';
import discord from '../../Web Mundo/discord.png';

// =======================
// Modal animation & style
// =======================
const glowBorder = keyframes`
  0% {
    box-shadow: 0 0 10px rgba(255,215,0,0.4), 0 0 0 rgba(255,215,0,0.1);
  }
  50% {
    box-shadow: 0 0 22px rgba(255,215,0,0.9), 0 0 26px rgba(255,215,0,0.4);
  }
  100% {
    box-shadow: 0 0 10px rgba(255,215,0,0.4), 0 0 0 rgba(255,215,0,0.1);
  }
`;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 300, sm: 420, md: 540 },
  maxHeight: '80vh',
  bgcolor: '#050710',
  borderRadius: 3,
  p: 2.2,
  color: 'white',
  overflowY: 'auto',
  border: '1px solid rgba(255,215,0,0.8)',
  animation: `${glowBorder} 4s ease-in-out infinite`,
};

// =======================
// Component
// =======================
const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState('Error');
  const [password, setPassword] = React.useState('');
  const [deposit, setDeposit] = React.useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [peticion] = useFetch();
  const { informacion } = useSelector((state) => state.userSlice);

  // =======================
  // Actualizar usuario / saldos globales
  // =======================

  // ✅ Esta función ahora acepta varias formas de respuesta:
  // data.usuario
  // data.user
  // data.resultado.usuario
  // data.resultado.user
  // data.resultado  <--- ESTA era la que faltaba
  const extraerUsuarioRespuesta = (data) => {
    const posibleUsuario =
      data?.usuario ||
      data?.resultado?.usuario ||
      data?.resultado?.user ||
      data?.user ||
      data?.resultado ||
      null;

    if (!posibleUsuario || typeof posibleUsuario !== 'object') {
      return null;
    }

    // ✅ Validación para no meter cualquier objeto incorrecto en Redux
    const pareceUsuario =
      typeof posibleUsuario.dinero !== 'undefined' ||
      typeof posibleUsuario.dineroReal !== 'undefined' ||
      typeof posibleUsuario.fusion !== 'undefined' ||
      typeof posibleUsuario.energia !== 'undefined' ||
      typeof posibleUsuario.nombre !== 'undefined';

    if (!pareceUsuario) {
      return null;
    }

    return posibleUsuario;
  };

  const actualizarInformacionUsuario = React.useCallback(async () => {
    try {
      const tokenJWT = getCookie('token');

      if (!tokenJWT) {
        console.log('[NavBar] ⚠️ No hay token para actualizar saldos.');
        return null;
      }

      const res = await axios.get(rutas.getInformacion, {
        headers: { token: tokenJWT },
      });

      const usuarioActualizado = extraerUsuarioRespuesta(res.data);

      if (usuarioActualizado) {
        console.log('[NavBar] ✅ Usuario actualizado desde getInformacion:', {
          nombre: usuarioActualizado?.nombre,
          dinero: usuarioActualizado?.dinero,
          dineroReal: usuarioActualizado?.dineroReal,
          fusion: usuarioActualizado?.fusion,
          energia: usuarioActualizado?.energia,
        });

        dispatch(setInformacion(usuarioActualizado));
        return usuarioActualizado;
      }

      console.log(
        '[NavBar] ⚠️ getInformacion respondió, pero no se pudo extraer usuario:',
        res.data
      );

      return null;
    } catch (error) {
      console.error(
        '[NavBar] Error actualizando información/saldos:',
        error?.response?.data || error?.message || error
      );

      return null;
    }
  }, [dispatch]);

  React.useEffect(() => {
    actualizarInformacionUsuario();

    const escucharActualizacion = () => {
      console.log('[NavBar] 🔄 Evento actualizar-saldos recibido.');
      actualizarInformacionUsuario();
    };

    const actualizarSiVuelveVisible = () => {
      if (document.visibilityState === 'visible') {
        console.log('[NavBar] 🔄 Pestaña visible otra vez. Actualizando saldos.');
        actualizarInformacionUsuario();
      }
    };

    window.addEventListener('actualizar-saldos', escucharActualizacion);
    window.addEventListener('focus', escucharActualizacion);
    document.addEventListener('visibilitychange', actualizarSiVuelveVisible);

    return () => {
      window.removeEventListener('actualizar-saldos', escucharActualizacion);
      window.removeEventListener('focus', escucharActualizacion);
      document.removeEventListener('visibilitychange', actualizarSiVuelveVisible);
    };
  }, [actualizarInformacionUsuario]);

  // =======================
  // Helpers perfil
  // =======================
  const bonus = (informacion?.nivel ?? 0) * 0.25;
  const missionsDone = informacion?.cantidadMision ?? 0;
  const missionsCap = 600;
  const missionsPct = Math.min(
    100,
    missionsCap > 0 ? (missionsDone / missionsCap) * 100 : 0
  );

  const formatoNumero = (valor) => {
    const numero = Number(valor || 0);

    return numero.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 8,
    });
  };

  // =======================
  // Handlers generales
  // =======================
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClose2 = () => setOpen2(false);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const cerrarSesion = () => {
    dispatch(exit({}));
    sessionStorage.setItem('user', JSON.stringify({ logged: false }));
    navigate('/login', { replace: true });
  };

  const handleChange = (e) => setPassword(e.target.value);

  // =======================
  // Transferencias HIVE-ENGINE
  // =======================
  const transfer = (cantidad, onSuccess, memo = 'Deposit', token = 'HUESO') => {
    const cantidadNumero = Number(cantidad);

    if (!Number.isFinite(cantidadNumero) || cantidadNumero <= 0) {
      setErrorText('Invalid deposit amount');
      setError(true);
      setOpen2(true);
      return;
    }

    if (!window.hive_keychain) {
      setErrorText('Hive Keychain is not available');
      setError(true);
      setOpen2(true);
      return;
    }

    const username = JSON.parse(sessionStorage.getItem('user') || '{}');

    if (!username?.user) {
      setErrorText('User session not found');
      setError(true);
      setOpen2(true);
      return;
    }

    const json = {
      contractName: 'tokens',
      contractAction: 'transfer',
      contractPayload: {
        symbol: token,
        to: 'mv-token1',
        quantity: cantidadNumero.toString(),
        memo: memo,
      },
    };

    window.hive_keychain.requestCustomJson(
      username.user,
      'ssc-mainnet-hive',
      'Active',
      JSON.stringify(json),
      'Transfer',
      async function (response) {
        if (response.success && response.result) {
          try {
            const tokenJWT = getCookie('token');

            const resultado = await axios.post(
              rutas.deposit,
              {
                id: response?.result?.id,
              },
              {
                headers: { token: tokenJWT },
              }
            );

            if (resultado.status === 200) {
              const usuarioActualizado = extraerUsuarioRespuesta(resultado.data);

              if (usuarioActualizado) {
                dispatch(setInformacion(usuarioActualizado));
              } else {
                await actualizarInformacionUsuario();
              }

              window.dispatchEvent(new Event('actualizar-saldos'));

              setError(false);
              setErrorText('');
              setDeposit(0);

              if (typeof onSuccess === 'function') {
                onSuccess();
              }
            }
          } catch (error) {
            console.error(
              '[Deposit] Error:',
              error?.response?.data || error?.message || error
            );

            setErrorText(
              error?.response?.data?.error || 'Deposit could not be completed'
            );
            setError(true);
            setOpen2(true);

            await actualizarInformacionUsuario();
          }
        } else {
          console.log(response);

          setErrorText(response?.message || 'Transaction rejected or cancelled');
          setError(true);
          setOpen2(true);
        }
      }
    );
  };

  const handleTransfer = (token = 'HUESO') => {
    transfer(deposit, () => setOpen2(true), 'Deposit', token);
  };

  // =======================
  // Retiros
  // =======================
  const retiroInterno = async () => {
    try {
      const tokenJWT = getCookie('token');

      const resultado = await axios({
        method: 'get',
        url: rutas.retiroInterno,
        headers: {
          token: tokenJWT,
          'Content-Type': 'application/json',
        },
      });

      if (resultado?.data) {
        const usuarioActualizado = extraerUsuarioRespuesta(resultado.data);

        if (usuarioActualizado) {
          dispatch(setInformacion(usuarioActualizado));
        } else {
          await actualizarInformacionUsuario();
        }

        window.dispatchEvent(new Event('actualizar-saldos'));

        setError(false);
        setErrorText('');
        setOpen2(true);
      } else {
        setError(true);
        setErrorText('Withdraw failed');
        setOpen2(true);
      }
    } catch (error) {
      setErrorText(error?.response?.data?.error || 'Withdraw failed');
      setError(true);
      setOpen2(true);

      await actualizarInformacionUsuario();
    }
  };

  const retiroDinero = async () => {
    try {
      const tokenJWT = getCookie('token');

      const resultado = await axios({
        method: 'get',
        url: rutas.retiro,
        headers: {
          token: tokenJWT,
          'Content-Type': 'application/json',
        },
      });

      if (resultado?.data) {
        const usuarioActualizado = extraerUsuarioRespuesta(resultado.data);

        if (usuarioActualizado) {
          dispatch(setInformacion(usuarioActualizado));
        } else {
          await actualizarInformacionUsuario();
        }

        window.dispatchEvent(new Event('actualizar-saldos'));

        setError(false);
        setErrorText('');
        setOpen2(true);
      } else {
        setError(true);
        setErrorText('Withdraw failed');
        setOpen2(true);
      }
    } catch (error) {
      setErrorText(error?.response?.data?.error || 'Withdraw failed');
      setError(true);
      setOpen2(true);

      await actualizarInformacionUsuario();
    }
  };

  // =======================
  // Cambiar password
  // =======================
  const changePassword = async () => {
    try {
      if (password === '' || password.length < 4 || password.length > 12) {
        setErrorText('Invalid password');
        setError(true);
        setOpen2(true);
        return;
      }

      const tokenJWT = getCookie('token');

      const resultado = await axios({
        method: 'post',
        url: rutas.changePass,
        headers: {
          token: tokenJWT,
          'Content-Type': 'application/json',
        },
        data: { password },
      });

      if (resultado?.data) {
        setPassword('');
        setError(false);
        setErrorText('');
        setOpen2(true);
      }
    } catch (error) {
      setErrorText(error?.response?.data?.error || 'Could not change password');
      setError(true);
      setOpen2(true);
    }
  };

  // =======================
  // Render
  // =======================
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* MENÚ MÓVIL */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'flex' },
              justifyContent: 'space-between',
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem onClick={handleCloseNavMenu}>
                <Link
                  style={{ color: 'white', textDecoration: 'none' }}
                  to="/game/"
                >
                  INICIO
                </Link>
              </MenuItem>

              <MenuItem onClick={handleCloseNavMenu}>
                <Link
                  style={{ color: 'white', textDecoration: 'none' }}
                  to="/game/album"
                >
                  ALBUM
                </Link>
              </MenuItem>

              <MenuItem onClick={handleCloseNavMenu}>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                  }}
                  to="/game/market"
                >
                  in-game market
                </Link>
              </MenuItem>

              <MenuItem onClick={handleCloseNavMenu}>
                <Link
                  style={{ color: 'white', textDecoration: 'none' }}
                  to="/game/inventory"
                >
                  INVENTORY
                </Link>
              </MenuItem>

              <MenuItem onClick={handleCloseNavMenu}>
                <Link
                  style={{ color: 'white', textDecoration: 'none' }}
                  to="/game/stake"
                >
                  STAKE
                </Link>
              </MenuItem>
            </Menu>
          </Box>

          {/* LOGO */}
          <CardMedia
            component="img"
            image={logo}
            alt="avatar"
            sx={{ width: '90px', display: { xs: 'none', md: 'block' } }}
          />

          {/* MENÚ DESKTOP */}
          <Box
            sx={{
              width: { xs: '100%', sm: '72%' },
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'space-evenly',
            }}
          >
            <Button
              to="/game/"
              component={Link}
              sx={{ width: '150px' }}
              variant="contained"
            >
              <Link
                style={{ color: 'white', textDecoration: 'none' }}
                to="/game/"
              >
                INICIO
              </Link>
            </Button>

            <Button
              to="/game/market/"
              component={Link}
              sx={{ width: '170px' }}
              variant="contained"
            >
              <Link
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  textTransform: 'uppercase',
                }}
                to="/game/market"
              >
                in-game market
              </Link>
            </Button>

            <Button
              to="/game/album"
              component={Link}
              sx={{ width: '150px' }}
              variant="contained"
            >
              <Link
                style={{ color: 'white', textDecoration: 'none' }}
                to="/game/album"
              >
                ALBUM
              </Link>
            </Button>

            <Button
              to="/game/inventory"
              component={Link}
              sx={{ width: '150px' }}
              variant="contained"
            >
              <Link
                style={{ color: 'white', textDecoration: 'none' }}
                to="/game/inventory"
              >
                INVENTORY
              </Link>
            </Button>

            <Link
              style={{ color: 'white', textDecoration: 'none' }}
              to="/game/stake"
            >
              <Button sx={{ width: '150px' }} variant="contained">
                STAKE
              </Button>
            </Link>
          </Box>

          {/* INFO DERECHA (Hueso, energía, iconos) */}
          <Box
            sx={{
              width: { xs: '85%', md: '25%' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 0.4,
            }}
          >
            <Typography sx={{ color: 'gold', fontWeight: 'bold' }}>
              {formatoNumero(informacion?.dinero)}
            </Typography>

            <CardMedia
              component="img"
              sx={{ width: '20px', mr: 1 }}
              image={hueso}
              alt="Hueso"
            />

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>
                {informacion?.energia?.actual ?? 0} /
              </Typography>

              <Typography>
                {informacion?.energia?.maximo ?? 0}
              </Typography>

              <EvStationIcon sx={{ fontSize: '35px' }} />

              <AccountCircleIcon
                onClick={handleOpen}
                sx={{ fontSize: '35px', cursor: 'pointer' }}
              />

              <ExitToAppIcon
                onClick={cerrarSesion}
                sx={{ fontSize: '35px', '&:hover': { cursor: 'pointer' } }}
              />

              <a
                href="https://mundo-virtual.gitbook.io/whitepaper/"
                target="_blank"
                rel="noreferrer"
              >
                <BookIcon
                  sx={{
                    fontSize: '35px',
                    '&:hover': { cursor: 'pointer', fontStyle: 'none' },
                  }}
                />
              </a>

              <a
                href="https://discord.gg/GJS6MtKB2x"
                target="_blank"
                rel="noreferrer"
              >
                <CardMedia
                  component="img"
                  image={discord}
                  alt="discord"
                  sx={{
                    width: { xs: '1.4rem', md: '1.7rem' },
                    height: {
                      xs: '1.4rem',
                      md: '1.7rem',
                      '&:hover': { cursor: 'pointer' },
                    },
                  }}
                />
              </a>
            </Box>
          </Box>
        </Toolbar>
      </Container>

      {/* ======================= MODAL PERFIL ======================= */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* HEADER */}
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
            <Avatar
              sx={{
                bgcolor: 'goldenrod',
                width: 44,
                height: 44,
                fontWeight: 'bold',
                fontSize: 20,
                boxShadow: '0 0 14px rgba(255,215,0,0.9)',
              }}
            >
              {informacion?.nombre?.charAt(0)?.toUpperCase() || '?'}
            </Avatar>

            <Box sx={{ flexGrow: 1 }}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                sx={{ fontWeight: 'bold', letterSpacing: 1 }}
              >
                {informacion?.nombre || 'Player'}
              </Typography>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 0.3, flexWrap: 'wrap' }}
              >
                <Chip
                  size="small"
                  label={`Level ${informacion?.nivel ?? 0}`}
                  sx={{
                    bgcolor: 'rgba(255,165,0,0.15)',
                    border: '1px solid rgba(255,165,0,0.7)',
                    color: 'orange',
                  }}
                />

                <Chip
                  size="small"
                  label={`Bonus ${bonus.toFixed(2)}%`}
                  sx={{
                    bgcolor: 'rgba(50,205,50,0.15)',
                    border: '1px solid rgba(50,205,50,0.8)',
                    color: 'lime',
                  }}
                />
              </Stack>
            </Box>
          </Stack>

          <Divider sx={{ mb: 1.5, borderColor: 'rgba(255,255,255,0.1)' }} />

          {/* ESTADÍSTICAS EN 2 COLUMNAS */}
          <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
            {/* Columna izquierda */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: 1.2,
                  borderRadius: 2,
                  bgcolor: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ mb: 0.6, color: 'gold', fontWeight: 'bold' }}
                >
                  Player Stats
                </Typography>

                <Typography variant="body2">
                  <strong>Unique NFT:</strong> {informacion?.nftUnicos ?? 0}
                </Typography>

                <Typography variant="body2">
                  <strong>Percentage:</strong>{' '}
                  {(informacion?.porcentaje ?? 0).toFixed(2)}%
                </Typography>

                <Typography variant="body2" sx={{ mt: 0.6 }}>
                  <strong>Missions done:</strong> {missionsDone} / {missionsCap}{' '}
                  free before Power Collection
                </Typography>

                <Box
                  sx={{
                    mt: 0.5,
                    height: 6,
                    borderRadius: 999,
                    overflow: 'hidden',
                    bgcolor: 'rgba(255,255,255,0.06)',
                  }}
                >
                  <Box
                    sx={{
                      width: `${missionsPct}%`,
                      height: '100%',
                      background:
                        'linear-gradient(90deg, #FFD700, #FF9800, #FF5722)',
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Columna derecha */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: 1.2,
                  borderRadius: 2,
                  bgcolor: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ mb: 0.6, color: 'gold', fontWeight: 'bold' }}
                >
                  Power & Balances
                </Typography>

                <Typography variant="body2">
                  <strong>Power Hueso:</strong> {formatoNumero(informacion?.ph)}
                </Typography>

                <Typography variant="body2">
                  <strong>Power energy:</strong> {formatoNumero(informacion?.pe)}
                </Typography>

                <Typography variant="body2">
                  <strong>HUESO in game:</strong> {formatoNumero(informacion?.dinero)}
                </Typography>

                <Typography variant="body2">
                  <strong>HUESO wallet:</strong> {formatoNumero(informacion?.dineroReal)}
                </Typography>

                <Typography variant="body2">
                  <strong>VIPHUESO:</strong> {formatoNumero(informacion?.fusion)}
                </Typography>

                <Typography variant="body2">
                  <strong>Energy:</strong>{' '}
                  {informacion?.energia?.actual ?? 0} / {informacion?.energia?.maximo ?? 0}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ mt: 0.4, color: 'lime', fontWeight: 'bold' }}
                >
                  Total Bonus: {bonus.toFixed(2)}%
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1.5, borderColor: 'rgba(255,255,255,0.1)' }} />

          {/* CUENTA / PASSWORD */}
          <Typography variant="body2" sx={{ mb: 0.6, fontWeight: 'bold' }}>
            Account & Security
          </Typography>

          <TextField
            value={password}
            onChange={handleChange}
            type="password"
            fullWidth
            label="New password"
            variant="standard"
            sx={{ mb: 1.5 }}
          />

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            sx={{ mb: 1.5 }}
          >
            <Button
              disabled={!informacion?.packInicial}
              onClick={retiroInterno}
              variant="contained"
              fullWidth
            >
              {informacion?.packInicial
                ? 'Withdraw in game'
                : 'Buy Initial pack'}
            </Button>

            <Button onClick={changePassword} variant="outlined" fullWidth>
              Change Password
            </Button>
          </Stack>

          <Divider sx={{ my: 1.5, borderColor: 'rgba(255,255,255,0.1)' }} />

          {/* DEPÓSITOS */}
          <Typography variant="body2" sx={{ mb: 0.6, fontWeight: 'bold' }}>
            Deposits
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            sx={{ mb: 1 }}
          >
            <TextField
              value={deposit}
              onChange={(e) => setDeposit(e.target.value)}
              type="number"
              fullWidth
              label="Amount to deposit"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Stack>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            sx={{ mb: 1.5 }}
          >
            <Button
              onClick={() => handleTransfer('HUESO')}
              variant="contained"
              fullWidth
            >
              Deposit HUESO
            </Button>

            <Button
              onClick={() => handleTransfer('VIPHUESO')}
              variant="contained"
              color="secondary"
              fullWidth
            >
              Deposit VIPHUESO
            </Button>

            <Button
              onClick={retiroDinero}
              variant="outlined"
              color="warning"
              fullWidth
            >
              Withdraw All
            </Button>
          </Stack>

          <Divider sx={{ my: 1.5, borderColor: 'rgba(255,255,255,0.1)' }} />

          {/* REFERRAL */}
          <Typography variant="body2" sx={{ mb: 0.4, fontWeight: 'bold' }}>
            Referral link
          </Typography>

          <Typography
            variant="body2"
            sx={{
              wordBreak: 'break-all',
              color: 'rgba(255,255,255,0.8)',
            }}
          >
            {`https://www.bigdogbonegame.com/login/${informacion?.nombre}`}
          </Typography>
        </Box>
      </Modal>

      {/* SNACKBAR GLOBAL */}
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
          {error ? (
            <Alert
              onClose={handleClose2}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >
              {errorText}
            </Alert>
          ) : (
            <Alert
              onClose={handleClose2}
              severity="success"
              variant="filled"
              sx={{ width: '100%' }}
            >
              Success
            </Alert>
          )}
        </Snackbar>
      </Stack>
    </AppBar>
  );
};

export default NavBar;